import { render, staticRenderFns } from "./DeleteConfirmationDialog.vue?vue&type=template&id=767cdba7&scoped=true"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeleteConfirmationDialog.vue?vue&type=style&index=0&id=767cdba7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cdba7",
  null
  
)

export default component.exports